import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography, Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { useRedirectsDialog } from "../../../app/components/RedirectsDialogProvider";
import { useRedirectsTable } from "../RedirectsTable/RedirectsTableContextProvider";
import { GridRowId } from "@mui/x-data-grid-pro";
type RedirectsDeleteProps = {
  selectedRedirects: GridRowId[];
};
const RedirectsDelete: FC<RedirectsDeleteProps> = ({
  selectedRedirects
}) => {
  const {
    t
  } = useTranslation();
  const {
    openDeleteDialog
  } = useRedirectsDialog();
  const {
    apiRef,
    redirects
  } = useRedirectsTable();
  const handleDelete = () => {
    const deleteData = selectedRedirects.map((ZUID: any) => ({
      ZUID,
      path: redirects.find((row: any) => row.ZUID === ZUID)?.path
    }));
    openDeleteDialog(deleteData);
  };
  return <Box width="100%" sx={{
    backgroundColor: "background.paper",
    alignItems: "center",
    justifyContent: "space-between",
    display: "flex",
    top: "0",
    zIndex: 2
  }} data-sentry-element="Box" data-sentry-component="RedirectsDelete" data-sentry-source-file="RedirectsDelete.tsx">
      <Typography variant="h3" fontWeight="700" data-sentry-element="Typography" data-sentry-source-file="RedirectsDelete.tsx">
        {t("seo.selectedCount", {
        count: selectedRedirects.length
      })}
      </Typography>
      <Box display="flex" justifyContent="space-between" alignItems="center" columnGap={1} data-sentry-element="Box" data-sentry-source-file="RedirectsDelete.tsx">
        <Button data-cy="RedirectActionDeselectAll" variant="outlined" color="inherit" size="small" disabled={!selectedRedirects?.length} onClick={() => apiRef.current?.setRowSelectionModel([])} startIcon={<ClearIcon />} data-sentry-element="Button" data-sentry-source-file="RedirectsDelete.tsx">
          {t("shell.relationalDeselectAll")}
        </Button>
        <Button data-cy="RedirectActionSelectAll" variant="outlined" color="inherit" size="small" disabled={selectedRedirects?.length === redirects?.length} onClick={() => apiRef.current?.setRowSelectionModel(redirects.map((row: any) => row.ZUID))} startIcon={<DoneAllIcon />} data-sentry-element="Button" data-sentry-source-file="RedirectsDelete.tsx">
          {t("seo.selectAll")}
        </Button>
        <Button data-cy="RedirectActionDeleteButton" variant="contained" color="error" size="small" onClick={() => handleDelete()} startIcon={<DeleteIcon />} data-sentry-element="Button" data-sentry-source-file="RedirectsDelete.tsx">
          {t("common.delete")}
        </Button>
      </Box>
    </Box>;
};
export default RedirectsDelete;